import api from "../helpers/util";

export const fetchDeliveryMethod = async () => {
    try {
      const response = await api.get("/deliverymethod");
      return response?.data?.result?? 'No delivery methods found.';
    } catch (error) {
      throw new Error("Error fetching deliverymethods:", error);
    }
  };